export const faq = {
    searchFields : ['title', 'launchSearch', 'countEntities'],
    filterTitleToTranslate: 'faq.title',
    displayedFiltersIcons: false,
    rolesCanShowBannerInfo: ['trainer']
};
